module.exports = __webpack_public_path__ + "img/s1_t1_22.94782cff.jpeg";